export default "__VITE_ASSET__8f8196d2__"